import { render, staticRenderFns } from "./QuestionCard.vue?vue&type=template&id=7dc2d75c&scoped=true"
import script from "./QuestionCard.vue?vue&type=script&lang=ts"
export * from "./QuestionCard.vue?vue&type=script&lang=ts"
import style0 from "./QuestionCard.vue?vue&type=style&index=0&id=7dc2d75c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc2d75c",
  null
  
)

export default component.exports